import { BulkActionErrorCode } from "@common/constants/financial-documents";
import { z } from "zod";

export const LinkedDocumentFieldUpdateErrorSchema = z.object({
    code: z.literal(BulkActionErrorCode.DOCUMENT_LINKED_TO_IMPORTED_ACCOUNT),
});

export type LinkedDocumentFieldUpdateError = z.infer<
    typeof LinkedDocumentFieldUpdateErrorSchema
>;
